import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '@Components/Button/Button';
import Timer from '@Services/Timer';

import './ToastMessage.custom.scss';
import './ToastMessage.theme.scss';

export default class ToastMessage extends React.PureComponent {
  render () {
    const {
      children,
      iconId,
      icon,
      className,
      title,
      content,
      removingInProgress,
      animationEnterClass,
      animationExitClass,
      closeBtn,
    } = this.props;

    const sectionEvents = closeBtn ?
      {
        onMouseEnter: () => this.hideTimer && this.hideTimer.pause(),
        onMouseLeave: () => this.hideTimer && this.hideTimer.resume(),
      } :
      {
        onClick: this.clickHandler,
      };

    const iconComponent = iconId ?
      (
        <div className="toast-message-icon-container">
          <svg className="toast-message-icon">
            <use xlinkHref={iconId}/>
          </svg>
        </div>
      ) :
      icon ?
        (
          <div className="toast-message-icon-container">
              <span className="toast-message-icon">
                {icon}
              </span>
          </div>
        ) :
        null;

    const titleComponent = title ?
      (
        <div className='toast-message-title-container'>
          <h5 className='toast-message-title'>
            {title}
          </h5>
        </div>
      ) :
      null;

    const animationClass = removingInProgress ?
      animationExitClass :
      animationEnterClass;

    return (
      <section
        className={classnames('toast-message', animationClass, className)}
        {...sectionEvents}
      >
        {closeBtn &&
        <Button
          onClick={this.clickHandler}
          buttonConfig={{
            type: 'link',
            size: 'sm',
            className: 'els-btn-modal-close',
            iconOnly: true,
            ariaLabel: 'Close',
            e2eName: 'modal-close',
          }}
          iconConfig={{ name: 'delete', size: 'tiny' }}
        />
        }
        {iconComponent}
        <div className='toast-message-content-wrapper'>
          {titleComponent}
          <div className='toast-message-content-container'>
            {children}
            {content}
          </div>
        </div>
      </section>
    );
  }

  componentDidUpdate (prevProps) {
    const { removingInProgress } = this.props;

    if (!prevProps.removingInProgress && removingInProgress) {
      this.perfomDeletion();
    }
  }

  clickHandler = () => {
    const {
      id,
      userClickAction,
    } = this.props;

    userClickAction(id);
  }

  perfomDeletion () {
    const { removeToastMessage, id, hideAnimationTime } = this.props;

    this.hideAnimationTimer = new Timer(() => removeToastMessage(id), hideAnimationTime);
    this.hideTimer && this.hideTimer.clear();
  }

  componentDidMount () {
    const {
      id,
      hideTime,
      hideOnTime,
      removingInProgress,
      setRemovingToastMessage,
    } = this.props;

    if (hideOnTime && !removingInProgress) {
      this.hideTimer = new Timer(() => setRemovingToastMessage(id), hideTime);
    }
  }

  componentWillUnmount () {
    this.hideTimer && this.hideTimer.clear();
    this.hideAnimationTimer && this.hideAnimationTimer.clear();
  }
}

ToastMessage.defaultProps = {
  hideAnimationTime: 700,
  hideTime: 5000,
  hideOnTime: true,
  animationEnterClass: 'toast-message-slide-enter-top-right',
  animationExitClass: 'toast-message-slide-exit-top-right',
};

ToastMessage.propTypes = {
  className: PropTypes.string,
  hideTime: PropTypes.number,
  hideAnimationTime: PropTypes.number,
  hideOnTime: PropTypes.bool,
  removingInProgress: PropTypes.bool,
  id: PropTypes.string.isRequired,
  removeToastMessage: PropTypes.func.isRequired,
  setRemovingToastMessage: PropTypes.func.isRequired,
  userClickAction: PropTypes.func.isRequired,
  closeBtn: PropTypes.bool,
};
